/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendCustomerProfitEmailCommand } from '../../models/send-customer-profit-email-command';
import { Success } from '../../models/success';

export interface SendCustomerProfitEmailAsync$Plain$Params {
      body?: SendCustomerProfitEmailCommand
}

export function sendCustomerProfitEmailAsync$Plain(http: HttpClient, rootUrl: string, params?: SendCustomerProfitEmailAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Success>> {
  const rb = new RequestBuilder(rootUrl, sendCustomerProfitEmailAsync$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Success>;
    })
  );
}

sendCustomerProfitEmailAsync$Plain.PATH = '/api/report/customer/profits';
